import React, { Fragment, Component } from 'react';
import { getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { get } from 'lodash';
import moment from 'moment';

import { withReportSubscription } from 'State/report/withReportSubscription';
import { SalesAnalysisReportFieldEnum as Fields } from 'Common/FieldEnum';
import { SALES_ANALYSIS_REPORT_FORM_NAME } from 'Common/FormEnum';
import { DATE_FORMAT_FOR_UI } from 'Common/Constants';
import { Filter, Main } from 'Containers/';

import { SalesAnalysisReportForm } from './components/SalesAnalysisReportForm';
import { getUsersAction } from '../transactionhistory/state/actions';
import * as SalesAnalysisSelectors from './state/selector';
import * as SalesAnalysisActions from './state/actions';

class SalesAnalysisReportContainer extends Component {
  componentDidMount() {
    this.props.getUsersAction();
  }
  initialValues = () => {
    return {
      [Fields.AllDates]: false,
      [Fields.MealTypes]: [],
      [Fields.SiteId]:
        Array.isArray(this.props.sites) && this.props.sites.length === 1
          ? this.props.sites[0].Id
          : 'ALL',
      [Fields.UserId]: '',
      [Fields.Statuses]: [],
      [Fields.Grade]: '',
      [Fields.FromDate]: moment().format(DATE_FORMAT_FOR_UI),
      [Fields.ToDate]: moment().format(DATE_FORMAT_FOR_UI),
    };
  };

  getMainProps = () => {
    const { reportFetching } = this.props;

    return {
      toolbox: {
        formName: SALES_ANALYSIS_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'Print',
          loading: reportFetching,
          disabled: reportFetching,
        },
        shown: true,
      },
    };
  };

  handleSubmit = values => {
    const { getReport } = this.props;
    getReport('reports/SalesAnalysisReport', values);
  };

  handleSiteChange = siteId => {
    const { getGrades, sites } = this.props;

    if (siteId === 'ALL') {
      const formattedSites = sites.map(x => x.Id);
      getGrades(formattedSites);
    } else {
      getGrades([siteId]);
    }
  };

  render() {
    const {
      reportFetching,
      formValues,
      getGrades,
      userData,
      grades,
      sites,
    } = this.props;
    return (
      <Fragment>
        <Filter title={'Sales Analysis Report'} />
        <Main {...this.getMainProps()}>
          <SalesAnalysisReportForm
            allDatesSelected={get(formValues, Fields.AllDates, false)}
            selectedStatuses={get(formValues, Fields.Statuses, [])}
            initialValues={this.initialValues()}
            onSiteChange={this.handleSiteChange}
            onSubmit={this.handleSubmit}
            loading={reportFetching}
            getGrades={getGrades}
            usersData={userData}
            gradesData={grades}
            sites={sites}
          />
        </Main>
      </Fragment>
    );
  }
}

const mapStateToProps = state => {
  return {
    grades: SalesAnalysisSelectors.getGrades(state),
    errors: SalesAnalysisSelectors.getErrors(state),
    sites: SalesAnalysisSelectors.getSites(state),
    userData: SalesAnalysisSelectors.getUsers(state),
    formValues: getFormValues(SALES_ANALYSIS_REPORT_FORM_NAME)(state),
  };
};

const mapDispatchToProps = {
  getUsersAction,
  getGrades: SalesAnalysisActions.getGrades,
};

SalesAnalysisReportContainer = withReportSubscription(
  SalesAnalysisReportContainer
);

export const SalesAnalysisReport = connect(
  mapStateToProps,
  mapDispatchToProps
)(SalesAnalysisReportContainer);



// WEBPACK FOOTER //
// ./src/pages/salesanalysis/SalesAnalysisReport.js